import { render } from "./UiBadge.vue?vue&type=template&id=5a3a886e&scoped=true"
import script from "./UiBadge.vue?vue&type=script&lang=js"
export * from "./UiBadge.vue?vue&type=script&lang=js"

import "./UiBadge.vue?vue&type=style&index=0&id=5a3a886e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3a886e"]])

export default __exports__